module.exports = __webpack_public_path__ + "media/images/emblems/Wiedlisbach-coat_of_arms-d4ceffaee11b800104c487715818350f.svg";